.contact-page {
  padding-bottom: 4rem;
}

.contact-header {
  background: var(--surface-color);
  padding: 4rem 0 2rem;
  text-align: center;
  border-bottom: 1px solid var(--border-color);
}

.contact-header h1 {
  font-family: 'Outfit', sans-serif;
  color: var(--text-primary);
  margin-bottom: 1rem;
  font-size: 3rem;
}

.contact-content {
  padding: 4rem 0;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 3rem;
  max-width: 1100px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }
}

.contact-info h2 {
  font-family: 'Outfit', sans-serif;
  color: var(--secondary-gold);
  margin-bottom: 0.75rem;
  font-size: 1.8rem;
}

.info-desc {
  color: var(--text-secondary);
  margin-bottom: 2rem;
  line-height: 1.6;
}

.info-cards {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.info-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.25rem;
  border-radius: 12px;
}

.info-card-icon {
  background: rgba(240, 180, 41, 0.1);
  color: var(--secondary-gold);
  padding: 0.75rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.info-card h4 {
  color: var(--text-primary);
  margin-bottom: 0.25rem;
  font-family: 'Outfit', sans-serif;
  font-size: 1rem;
}

.info-card p {
  color: var(--text-secondary);
  line-height: 1.5;
  font-size: 0.95rem;
  margin: 0;
}

.contact-form-wrapper {
  padding: 2.5rem;
  border-radius: 16px;
}

.contact-form-wrapper h2 {
  font-family: 'Outfit', sans-serif;
  color: var(--secondary-gold);
  margin-bottom: 0.5rem;
  font-size: 1.8rem;
}

.form-desc {
  color: var(--text-secondary);
  margin-bottom: 2rem;
  font-size: 0.95rem;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
}

@media (max-width: 600px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}

.contact-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0;
}

.contact-form .form-group label {
  color: var(--text-primary);
  font-weight: 500;
  font-size: 0.95rem;
}

.contact-form .form-group input,
.contact-form .form-group textarea,
.contact-form .form-group select {
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  color: var(--input-text);
  font-family: inherit;
  transition: all 0.3s ease;
  font-size: 1rem;
  width: 100%;
}

.contact-form .form-group input:focus,
.contact-form .form-group textarea:focus,
.contact-form .form-group select:focus {
  outline: none;
  border-color: var(--input-focus-border);
  box-shadow: var(--input-focus-shadow);
}

.captcha-container {
  display: flex;
  align-items: center;
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  margin-bottom: 0.5rem;
}

.captcha-container:hover {
  border-color: var(--secondary-gold);
}

.captcha-checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid var(--input-border);
  border-radius: 4px;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--surface-color);
  transition: all 0.3s;
}

.captcha-container.verified .captcha-checkbox {
  border-color: var(--success);
}

.submit-btn {
  margin-top: 0.5rem;
}
